interface Props {
  /** Tailwind 사이즈/색상 클래스 (예: "h-7 w-auto") */
  className?: string;
  /** 화면리더 노출용 라벨. 미지정 시 aria-hidden 처리. */
  ariaLabel?: string;
}

// 카카오톡 in-app browser 가 외부 svg/png 를 종종 차단/누락하는 이슈를 우회하기 위해
// public/images/logo_only.svg 를 React 컴포넌트로 인라인. HTTP 요청이 발생하지 않으므로
// in-app 환경에서 이미지 렌더 실패를 구조적으로 차단한다.
//
// 디자인 원본: public/images/logo_only.svg 와 viewBox / path 동일.
export function Logo({ className, ariaLabel }: Props) {
  const accessibilityProps = ariaLabel
    ? { role: 'img' as const, 'aria-label': ariaLabel }
    : { 'aria-hidden': true as const, focusable: false as const };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="28 46 84 60"
      fill="none"
      className={className}
      {...accessibilityProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.0001 95.0846C69.4544 95.7894 68.8622 96.4619 68.2243 97.0998C66.2958 99.0284 64.0498 100.542 61.5487 101.6C58.9602 102.695 56.2103 103.249 53.3753 103.249C50.5402 103.249 47.7903 102.695 45.2002 101.6C42.6999 100.542 40.4539 99.0284 38.5261 97.0998C36.5968 95.1704 35.0832 92.9253 34.0256 90.4242C32.9302 87.8348 32.375 85.0856 32.375 82.2506C32.375 79.8331 34.3335 77.8746 36.7503 77.8746C39.1664 77.8746 41.1249 79.8331 41.1249 82.2506C41.1249 85.522 42.3991 88.5987 44.7128 90.9116C47.0272 93.226 50.1032 94.5002 53.3753 94.5002C56.6473 94.5002 59.7241 93.226 62.0378 90.9116C64.3499 88.5987 65.6248 85.522 65.6248 82.2506C65.6248 82.1206 65.6311 81.9916 65.6421 81.8648C65.5886 81.8105 65.5366 81.7561 65.4846 81.6994L60.1588 75.8884C56.5575 71.9604 59.3445 65.625 64.6735 65.625H75.3268C80.6559 65.625 83.4428 71.9604 79.8416 75.8884L74.5149 81.6994C74.4637 81.7561 74.4117 81.8105 74.3581 81.8648C74.3692 81.9916 74.3747 82.1199 74.3747 82.2499C74.3747 85.5212 75.6489 88.5979 77.9626 90.9116C80.2771 93.226 83.353 94.5002 86.6251 94.5002C89.8971 94.5002 92.9739 93.226 95.2876 90.9116C97.6005 88.5987 98.8754 85.522 98.8754 82.2499C98.8763 79.8331 100.835 77.8746 103.25 77.8746C105.666 77.8746 107.624 79.8331 107.625 82.2499C107.625 85.0857 107.07 87.8365 105.974 90.4242C104.917 92.9253 103.403 95.1704 101.475 97.0998C99.5456 99.0284 97.3005 100.543 94.7993 101.6C92.21 102.695 89.4609 103.249 86.6251 103.249C83.7901 103.249 81.0401 102.695 78.4508 101.6C75.9498 100.543 73.7045 99.0284 71.776 97.0998C71.1381 96.4619 70.5459 95.7894 70.0001 95.0846V95.0846Z"
        fill="#1578CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.125 56C111.125 60.3494 107.599 63.875 103.25 63.875C98.9014 63.875 95.375 60.3494 95.375 56C95.375 51.6506 98.9014 48.125 103.25 48.125C107.599 48.125 111.125 51.6506 111.125 56V56Z"
        fill="#1578CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.625 56C44.625 60.3494 41.0994 63.875 36.75 63.875C32.4006 63.875 28.875 60.3494 28.875 56C28.875 51.6506 32.4006 48.125 36.75 48.125C41.0994 48.125 44.625 51.6506 44.625 56V56Z"
        fill="#1578CF"
      />
    </svg>
  );
}
